(function() {
    var gsSteps = require('diy/site-admin/guided-setup/steps');
    var $ = require('jquery');
    var api = require('../api');
    var siteadmin = require('../siteadmin');
    var features = require('diy/util/features');

    var NotificationApi = require('diy/toolbar/notificationNG/Api').default;
    var NotificationType = require('diy/toolbar/notificationNG/definitions/Type').default;

    /**
     * the content element, it is initially null.
     * it's populated from afterFillContent method
     */
    var contentEl = null,
        msg = jimdoData.messages.guidedSetup,
        showReminderCallout = -1,
        skipShowReminderCallout = false,
        skipKpiTracking = false,
        checkboxAutostartStatus = -1,
        gs_in_progress = -1,
        gsCompleted = false,
        gsNothingDone = true,
        gsIsScattered = false,
        firstUndoneStepEl,
        stackHeight = 118,

        GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT = 1401,
        GUIDEDSETUP_REMINDER_CALLOUT = 1402,
        GUIDEDSETUP_SHOW_AT_LOGIN = 1410,
        GUIDEDSETUP_CONGRATULATIONS_CALLOUT = 1404,
        GUIDEDSETUP_IN_PROGRESS = 1403
        ;

    /**
     * reference for within callbacks
     */
    var me = this;
    var stepData = gsSteps.getStepOptions(),
        gsBsaData = {};
    this.controllerLoaded = false;


    this.showCalloutCongratulations = function () {
        require(['diy/maintenanceMode/maintenanceMode'], function (maintenanceMode) {
            if (maintenanceMode.isFirstPublish()) {

                if (features("notificationsNG")) {
                    NotificationApi.schedule(function() {
                        NotificationApi.pushOne({
                            type: NotificationType.CONGRATS
                        });
                    });

                } else {
                    var n = top.diy.editor.notifications;
                    n.api.ready(function () {
                        var congratsNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_CONGRATULATIONS);
                        if (congratsNotifications.length <= 0) {
                            n.api.createNotification({type: n.Notifications.TYPE_CONGRATULATIONS});
                        } else {
                            n.api.updateNotification(congratsNotifications[0].getId(), {dismissed: 0});
                        }
                    });
                }
            }

            // Delete notification on publish
            $(document).bind('diy-maintenance-mode-publish', function () {
                if (features("notificationsNG")) {
                    NotificationApi.schedule(function() {
                        NotificationApi.deleteOne(
                            NotificationType.CONGRATS
                        )
                    });

                } else {
                    var n = top.diy.editor.notifications;
                    var congratsNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_CONGRATULATIONS);
                    if (congratsNotifications.length > 0) {
                        n.api.deleteNotificationByType(n.Notifications.TYPE_CONGRATULATIONS);
                    }
                }
            });

            $.ajax({
                url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_CONGRATULATIONS_CALLOUT
            });
        });
    };

    this.showCalloutReminder = function () {
        api.activateCallout('cc-sa-item-guidedsetup', {
            triggerMode: 'none',
            hideLeftButton: true,
            hideRightButton: true,
            featureId: GUIDEDSETUP_REMINDER_CALLOUT,
            text: {
                title: msg.callout.title,
                content: msg.callout.content
            }
        });
    };

    var guidedSetupClosed = function () {
        var showOnLogin = $("input#guided_setup_checkbox").is(":checked"),
            trackingLinkId = (showOnLogin == true) ? 'step_cancelTopSet' : 'step_cancelTopUnSet';

        if (showReminderCallout == true) {
            if (skipShowReminderCallout == true) {
                skipShowReminderCallout = false;
            }
            else {
                $.ajax({
                    url: '/app/help/service/enable-feature/?id=' + GUIDEDSETUP_REMINDER_CALLOUT
                });
                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT
                });
                me.showCalloutReminder();
                showReminderCallout = false;
            }
        }
        if (skipKpiTracking == true) {
            skipKpiTracking = false;
        } else {
            $(document).trigger('diy-guidedSetup-closed', {
                'linkId': trackingLinkId
            });
        }

    };

    this.computeStackedScroll = function () {
        // prepare auto-scroll to the "right" step
        var autoScrollTop = 0;
        var sa = $('.gs-scrolled-area');

        if (gsNothingDone) {
            // no scrolling necesarry
        } else if (gsCompleted) {
            // auto-scroll to bottom
            autoScrollTop = sa.get(0).scrollHeight;
        } else if (gsIsScattered && firstUndoneStepEl) {
            // auto-scroll so that first undone item
            // will be in the middle
            var firstUndoneStepMiddleY =
                firstUndoneStepEl.offset().top + firstUndoneStepEl.height() / 2;

            var saMiddleY = sa.offset().top + sa.height() / 2;
            autoScrollTop = firstUndoneStepMiddleY - saMiddleY;
        } else if (firstUndoneStepEl) {
            // auto-scroll to a ratio of 4undone:3done items (as close as possible)
            // but no more thatn 4 undone items
            // this is a silly requirement, so don't complain about the solution :)
            var stickyH = 0;
            // simulate sticky just to get it's height
            if (sa.find('.gs-sticky-source').length > 0) {
                var sticky = sa.find('.gs-sticky-source').clone().appendTo(sa)
                    .addClass('gs-sticky')
                    .removeClass('gs-sticky-source');
                stickyH = sticky.outerHeight();
                sticky.remove();
            }
            var
                undoneSteps = firstUndoneStepEl.prev().nextAll('.gs-step'),
            // suppose all undone are of same height
                undoneH = firstUndoneStepEl.outerHeight(),
            // suppose all done are of the same height
                doneH = sa.find('.gs-step-finished').outerHeight(),
            // height of the visible area
                visibleH = sa.height() - stackHeight + undoneH - stickyH,
            // solving done*doneH + undone*undoneH = visibleH, where done/undone = 3/4
            // <=> undone(3/4*doneH + undoneH) = visibleH
                undone = Math.round(visibleH / (3 / 4 * doneH + undoneH))
                ;

            undone = Math.min(4, undone, undoneSteps.length);
            var
                lastVisibleUndone = undoneSteps.eq(undone - 1),
                stackOffsetTop = sa.offset().top + sa.height() - stackHeight
                ;
            autoScrollTop = Math.max(lastVisibleUndone.offset().top - stackOffsetTop, 0);
        }

        createStackedScroll();

        initStickyHeader();

        // auto-scroll to the "right" step
        sa.diy_stackedScroll('scrollTop', autoScrollTop);
    };

    this.updateFooter = function () {
        $('.gs-footer-1').find('input[type=checkbox]').diy_checkbox({
            boxLabel: msg.window.checkbox,
            change: function () {
                if (this.checked == true) {
                    $.ajax({
                        url: '/app/help/service/enable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                    });
                    checkboxAutostartStatus = true;
                } else {
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                    });
                    checkboxAutostartStatus = false;
                }
            },
            checked: checkboxAutostartStatus
        });
    };

    this.afterFillContent = function (el, payload, contentElement) {
        if (showReminderCallout == -1) {
            showReminderCallout = $('.gs-container').attr('data-show-reminder-callout') == "1";
        }
        if (checkboxAutostartStatus == -1) {
            checkboxAutostartStatus = $('.gs-container').attr('data-checkbox-autostart-status') == "1";
        }
        if (gs_in_progress == -1) {
            gs_in_progress = $('.gs-container').attr('data-gs-in-progress') == "1";
        }

        contentEl = contentElement;

        $(contentElement).loadingBox({
            useOverlay: true,
            overlayClass: "th-loading-opaque-overlay"
        }).show();

        this.buildStepDataHTML();

        api.updateTitle(msg.window.title);
        api.updateDescr(msg.window.description);
        api.updateNavi();
        api.updateHelpTopic('guidedSetup');
        $(document).one('diy-siteadmin-window-closed', guidedSetupClosed);

        $guidedSetup = $('.cc-sa-controller-guidedSetup #site-admin-iframe-content');
        $shareLink = $('.gs-share-link span:first');

        $('.gs-share-link').click(function () {
            $guidedSetup.toggleClass('gs-show-share');
            if ($guidedSetup.hasClass('gs-show-share')) {
                $shareLink.text($shareLink.parent().attr('data-collapse'));
            } else {
                $shareLink.text($shareLink.parent().attr('data-expand'));
            }
            onSAResize();
        });
        $guidedSetup.addClass('gs-show-share');
        $shareLink.text($shareLink.parent().attr('data-collapse'));

        createFooterShareButtons();

        $(document).bind('diy-siteadmin-window-resize-completed', onSAResize);

        /**
         * Open the "SiteAdmin->Settings->MyData" section when clicking on
         * Guided Setup "Enter My Data"
         * @see: DHDIYED-845
         */
        $("#guided_setup_personalDatas").bind("click", function () {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'personal-data'}
            ]);
        });

        this.controllerLoaded = true;
    };

    this.allowSwitch = function () {
        return this.controllerLoaded;
    };

    var getShareUrl = function () {
        var delimiter = '?';
        // add query string with timestamp to prevent social networks
        // to use a cached version of page when sharing
        if (jimdoData.webUrl.indexOf('?') !== -1) {
            delimiter = '&';
        }
        return jimdoData.webUrl + delimiter + (new Date().getTime());
    };

    var createFooterShareButtons = function () {
        createShareButtons(
            $('.gs-footer-1 .gs-share-buttons'),
            msg.shareNotCompletedText,
            msg.shareSocialMediaLinks
        );
    };
    var createStickyShareButtons = function () {
        createShareButtons(
            $('.gs-sticky-source .gs-share-buttons'),
            msg.shareCompletedText,
            msg.shareSocialMediaLinks
        );

        createShareButtons(
            $('.gs-sticky .gs-share-buttons'),
            msg.shareCompletedText,
            msg.shareSocialMediaLinks
        );

    };
    var getShareButtons = function (shareText, options) {
        var
            trackEvent = function (actionName) {
                var data = {
                    actionName: actionName,
                    pageName: 'Guided Setup'
                };
                top.jQuery(top.document).trigger('diy-editor-generic-linkInteraction', data);
            };
        var getFacebookAppId = require('diy/social/FacebookAppId');
        var fbAppId = getFacebookAppId();
        return [
            {
                type: 'facebookShare',
                options: {
                    appId: fbAppId,
                    url: getShareUrl(),
                    onClick: function () {
                        trackEvent('social_facebook');
                    },
                    onSubmit: function () {
                        trackEvent('social_facebook_success');
                    },
                    onSubmitCanceled: function () {
                        trackEvent('social_facebook_cancel');
                    },
                    actions: options.facebook.actions
                }
            },
            {
                type: 'twitterShare',
                options: {
                    url: ' ',
                    message: {
                        text: shareText
                    },
                    onClick: function () {
                        trackEvent('social_google+');
                    },
                    onSubmit: function () {
                        trackEvent('social_twitter_success');
                    }
                }
            },
            {
                type: 'linkedInShare',
                options: {
                    url: getShareUrl(),
                    onClick: function () {
                        trackEvent('social_linkedin');
                    }
                }
            },
            {
                type: 'xingShare',
                options: {
                    url: getShareUrl(),
                    onClick: function () {
                        trackEvent('social_xing');
                    }
                }
            }
        ];
    };

    var createShareButtons = function (container, shareText, shareLinks) {
        if (container.length > 0) {
            // cleanup first
            container.empty();

            require(
                ['diy/social/social'],
                /**
                 *
                 * @param social {diy.social.social}
                 */
                function (social) {
                    social.render(container, getShareButtons(shareText, social.config));
                }
            );
        }
    };


    var createStackedScroll = function () {
        $('.gs-scrolled-area').diy_stackedScroll({
            itemsSelector: '> *',
            visibleStackItems: 3,
            visibleStackOffset: 5,
            stackHeight: stackHeight,
            scroll: function () {
                var s = $('.gs-scrolled-area .gs-sticky-source');
                var sa = $('.gs-scrolled-area');

                if (sa.offset().top - s.offset().top > s.outerHeight() * 0.5) {
                    sa.find('.gs-sticky').css('visibility', 'visible');
                } else {
                    sa.find('.gs-sticky').css('visibility', 'hidden');
                }
            }
        });
    };

    var initStickyHeader = function () {
        var ss = $('.gs-scrolled-area .gs-sticky-source');
        var sa = $('.gs-scrolled-area');

        ss.clone()
            .addClass('gs-sticky')
            .removeClass('gs-sticky-source')
            .css('visibility', 'hidden')
            .width(ss.width())
            .appendTo(sa);


        if (gsCompleted) {
            createStickyShareButtons();
        }
    };

    var onSAResize = function () {
        // refresh stackedScroll only if already initialized
        var stackedScrollElements = $('.gs-scrolled-area');
        // check if instance of widget exists on the element
        if (stackedScrollElements.is(":diy-stackedScroll")) {
            stackedScrollElements.diy_stackedScroll('refresh');
        }
        $('.gs-sticky').width($('.gs-sticky-source').width());
    };

    this.buildStepDataHTML = function () {
        gsBsaData.baseUrl = bsaData.baseUrl + 'api/';

        var stepDataLength = stepData.length;
        if (stepDataLength <= 0) {
            return;
        }
        $('.gs-container').find('div[id^=step_]').remove();
        for (var i = 0; i < stepDataLength; i++) {
            $('.gs-scrolled-area').append(this.buildEachStepHtml(stepData[i], i));
        }

        $('.gs-container').find('.gs-step[id^=step_]').each(function (i, el) {
            $(el).bind('click', function (e) {
                var curPosition = $(this).attr('data-position');
                if ($(this).hasClass('gs-step-dependable')) {
                    $(this).toggleClass('gs-step-expanded');

                    var dependentStep = findStepByID(stepData[curPosition].getDependentStep());
                    if (dependentStep !== false) {
                        var dependentArrows = $('.gs-container').find('div#step_' + dependentStep.id + '.gs-step .gs-step-icon');
                        if (dependentArrows.length > 0) {
                            var dependentArrow = dependentArrows[0];
                            $(dependentArrow).toggleClass('gs-icon-dependent-on');
                            $(dependentArrow).parents('.gs-step').toggleClass('gs-dependent-on');
                        }
                    }

                    $('.gs-scrolled-area').diy_stackedScroll('refresh');
                } else if (stepData[curPosition].isVisible()) {
                    skipShowReminderCallout = true;
                    skipKpiTracking = true;
                    stepData[curPosition].getStartedTrigger();
                    trackStepLinkEvent(el);
                } else {
                    $(this).toggleClass('gs-step-expanded');
                    $('.gs-scrolled-area').diy_stackedScroll('refresh');
                }
            });
        });
        this.getRecommendablesInfo();
    };

    var trackStepLinkEvent = function (stepDataContainer) {
        $(document).trigger(
            'diy-editor-generic-linkInteraction',
            {
                actionName: $(stepDataContainer).attr('id')
            }
        );
    };

    this.getRecommendablesInfo = function () {
        var _self = this;
        $.ajax({
            async: true,
            type: 'get',
            url: gsBsaData.baseUrl + 'recommendables/',
            contentType: 'application/vnd.oneandone.bsa.recommendables+json',
            success: _self.updateStepBsaStatus
        });
    };


    this.buildTooltips = function () {
        var statusEls = $('.gs-container')
            .find('.gs-step .gs-step-icon.gs-step-completed');
        if (statusEls.length > 0) {
            for (var i = 0; i < statusEls.length; i++) {
                var curStepStatus = statusEls[i];

                var curStepAttribute = $(curStepStatus).attr('data-tooltip');
                var elmsDescription = $(curStepStatus).parent('.gs-step').find('.gs-step-description');
                if (typeof elmsDescription !== 'undefined'
                    && elmsDescription !== false
                    && elmsDescription.length > 0
                ) {
                    curStepAttribute = '<small>' + elmsDescription.html() + '</small><br />' + curStepAttribute;
                }
                if (typeof curStepAttribute !== 'undefined'
                    && curStepAttribute !== false
                    && curStepAttribute.length > 0
                ) {
                    $(curStepStatus).diy_simpleTooltip({
                        content: curStepAttribute,
                        cls: 'blueishTheme',
                        position: {
                            offset: '0 0'
                        }
                    });
                }
            }
        }
    };

    var isStepCompleted = function (step, recommendableData) {
        var j = 0, k = 0, eachStep;
        if (step.id !== 'internetAddress' && bsaData.isPreBsaWebsite) {
            return true;
        }
        var listOfRecommendables = [];
        for (j = 0; j < recommendableData.length; j++) {
            listOfRecommendables[recommendableData[j].name] = recommendableData[j].currentRank;
        }
        var rankedAchieved = false;
        if (step.hasOwnProperty('recommendablesOR')) {
            for (k = 0; k < step.recommendablesOR.length; k++) {
                eachStep = step.recommendablesOR[k];
                if (listOfRecommendables.hasOwnProperty(eachStep.recommendable) && listOfRecommendables[eachStep.recommendable] >= eachStep.minStatusRank) {
                    rankedAchieved = true;
                    break;
                }
            }
        } else {
            if (step.hasOwnProperty('recommendable')) {
                if (listOfRecommendables.hasOwnProperty(step.recommendable) && listOfRecommendables[step.recommendable] >= step.minStatusRank) {
                    rankedAchieved = true;
                }
            }
        }
        return rankedAchieved;
    };

    this.rewriteDependentStep = function (step) {
        var stepPlaceholders = $('.gs-container').find('div#step_' + step.id + '.gs-step');
        if (stepPlaceholders.length > 0) {
            var stepPlaceholder = stepPlaceholders[0];
            if ($(stepPlaceholder).hasClass('gs-step-unavailable')) {
                return;
            }
            var stepPlaceholderMarkup = '';
            stepPlaceholderMarkup += '<div class="gs-step-icon gs-step-incompleted">&nbsp;</div>';
            stepPlaceholderMarkup += '<div class="gs-step-inner">';
            stepPlaceholderMarkup += '<div class="gs-step-content">';
            stepPlaceholderMarkup += '<div class="gs-step-title">' + step.title + '</div>';
            stepPlaceholderMarkup += '<div class="gs-step-description">' + step.description + '</div>';
            stepPlaceholderMarkup += '<div class="gs-step-dependable-description">' + step.dependable + '</div>';
            ;
            stepPlaceholderMarkup += '</div>';
            stepPlaceholderMarkup += '<div class="gs-step-action">';
            stepPlaceholderMarkup += '<div class="gs-dependable-step-label">' + msg.dependableStep.label + '</div>';
            stepPlaceholderMarkup += '<div class="gs-dependable-step-more-info">&gt;&nbsp;' + msg.dependableStep.moreInfo + '</div>';
            stepPlaceholderMarkup += '<div class="gs-dependable-step-less-info">&gt;&nbsp;' + msg.dependableStep.lessInfo + '</div>';
            stepPlaceholderMarkup += '</div>';
            stepPlaceholderMarkup += '</div>';
            $(stepPlaceholder).addClass('gs-step-dependable').empty().append(stepPlaceholderMarkup);
        }
    };

    var findStepByID = function (stepID) {

        var i;
        var foundStep = false;

        for (i = 0; i < stepData.length; i++) {
            if (stepData[i].id === stepID) {
                foundStep = stepData[i];
                break;
            }
        }
        return foundStep;
    };

    this.updateStepBsaStatus = function (recommendableData) {
        var stepDataLength = stepData.length,
            visibleStepsLength = stepData.length;

        if (stepDataLength <= 0) {
            me.buildTooltips();
            me.updateFooter();
            $(contentEl).loadingBox().remove();
            return;
        }
        var finishSteps = 0;
        var previousStepIncomplete = false;
        gsIsScattered = false;
        firstUndoneStepEl = undefined;
        for (var i = 0; i < stepDataLength; i++) {
            var eachStep = stepData[i];
            var isStepVisible = eachStep.isVisible();
            if (!isStepVisible) {
                visibleStepsLength--;
            }
            if (isStepCompleted(eachStep, recommendableData)) {
                if (isStepVisible) {
                    finishSteps++;
                    if (previousStepIncomplete) {
                        gsIsScattered = true;
                    }
                    previousStepIncomplete = false;
                }
                var statusEls = $('.gs-container')
                    .find('div#step_' + eachStep.id + '.gs-step .gs-step-icon');
                if (statusEls.length > 0) {
                    if ($(statusEls[0]).hasClass('gs-step-incompleted')) {
                        $(statusEls[0]).removeClass('gs-step-incompleted');
                    }
                    $(statusEls[0]).addClass('gs-step-completed');
                    $(statusEls[0]).parents('.gs-step').addClass('gs-step-finished');
                }
            } else {

                if (typeof eachStep.getDependentStep === 'function') {
                    var dependentStep = findStepByID(eachStep.getDependentStep());
                    if (dependentStep !== false && !isStepCompleted(dependentStep, recommendableData)) {
                        me.rewriteDependentStep(eachStep);
                    }
                }
                if (isStepVisible) {
                    if (!firstUndoneStepEl) {
                        firstUndoneStepEl = $('.gs-container')
                            .find('div#step_' + eachStep.id);
                    }
                    previousStepIncomplete = true;
                }
            }
        }
        if (finishSteps > 0) {
            gsNothingDone = false;
        }
        if (finishSteps >= visibleStepsLength) {
            gsCompleted = true;

            //@see: DHDIYED-846
            $(".gs-share-link").hide();

            var statusEls = $('.gs-container')
                .find('.gs-final-check');
            if (statusEls.length > 0) {
                if ($(statusEls[0]).hasClass('gs-step-incompleted')) {
                    $(statusEls[0]).removeClass('gs-step-incompleted');
                }
                $(statusEls[0]).addClass('gs-step-completed');
            }
            if (gs_in_progress === true) {
                gs_in_progress = false;

                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_IN_PROGRESS
                });
                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                });
                if (showReminderCallout === true) {
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT
                    });
                    showReminderCallout = false;
                }

                checkboxAutostartStatus = false;

            }
            $('.cc-sa-controller-guidedSetup #site-admin-iframe-content')
                .removeClass('gs-show-share');
            $('.gs-share-link span:first').text($('.gs-share-link span:first').parent().attr('data-expand'));
            $('.gs-description').hide();
            $('.gs-completed').show();

        }

        me.computeStackedScroll();

        me.buildTooltips();
        me.updateFooter();
        $(contentEl).loadingBox().remove();
    };

    this.buildEachStepHtml = function (eachStep, position) {
        var hiddenStepClass = (eachStep.isVisible() ? '' : ' gs-step-unavailable');
        var eachStepMarkup = '';
        eachStepMarkup += '<div data-position="' + position + '" id="step_' + eachStep.id + '" class="gs-step' + hiddenStepClass + '">';
        eachStepMarkup += '<div class="gs-step-icon gs-step-incompleted" data-tooltip="' + eachStep.tooltip.finished + '">&nbsp;</div>';
        eachStepMarkup += '<div class="gs-step-inner">';
        eachStepMarkup += '<div class="gs-step-content">';
        eachStepMarkup += '<div class="gs-step-title">' + eachStep.title + '</div>';
        if (!eachStep.isVisible()) {
            eachStepMarkup += '<div class="gs-step-unavailable-description">' + eachStep.description + '<br />' + eachStep.unavailable + '</div>';
        } else {
            eachStepMarkup += '<div class="gs-step-description">' + eachStep.description + '</div>';
        }

        eachStepMarkup += '</div>';

        var actionHtml;

        if (eachStep.isVisible()) {
            actionHtml = '&gt;&nbsp;' + msg.window.getStartedStep;
        } else {
            actionHtml = '<div class="gs-unavailable-step-more-info">&gt;&nbsp;' + msg.unavailableStep.moreInfo + '</div>';
            actionHtml += '<div class="gs-unavailable-step-less-info">&gt;&nbsp;' + msg.unavailableStep.lessInfo + '</div>';
        }

        eachStepMarkup += '<div class="gs-step-action">' + actionHtml + '</div>';
        eachStepMarkup += '</div>';
        eachStepMarkup += '</div>';
        return eachStepMarkup;
    };

    /**
     * does this controller allows switching to another site-admin window?
     */
    this.allowSwitch = function () {
        guidedSetupClosed();
        $(document).unbind('diy-siteadmin-window-closed', guidedSetupClosed);
        $(document).unbind('diy-siteadmin-window-resize-completed', onSAResize);
        return true;
    };

    this.checkCongratulationsMsg = function () {
        me.isAllStepsCompleted({
            yes: function () {
                me.showCalloutCongratulations();
                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_IN_PROGRESS
                });
                $(document).trigger('diy-guidedsetup-steps-completed');
                $('body').unbind('bsa_event_called');
            }
        });
    };

    this.isAllStepsCompleted = function (options) {
        gsBsaData.baseUrl = bsaData.baseUrl + 'api/';
        $.ajax({
            async: true,
            type: 'get',
            url: gsBsaData.baseUrl + 'recommendables/',
            contentType: 'application/vnd.oneandone.bsa.recommendables+json',
            success: $.proxy(function (recommendableData) {
                this.isAllStepsCompletedCallback(recommendableData, options);
            }, this)
        });
    };

    this.isAllStepsCompletedCallback = function (recommendableData, options) {
        var stepDataLength = stepData.length,
            visibleStepsLength = stepData.length;

        if (stepDataLength <= 0) {
            return;
        }
        var finishSteps = 0;
        for (var i = 0; i < stepDataLength; i++) {
            if (!stepData[i].isVisible()) {
                visibleStepsLength--;
                continue;
            }
            if (isStepCompleted(stepData[i], recommendableData)) {
                finishSteps++;
            }
        }
        if (finishSteps >= visibleStepsLength) {
            if (options.yes && typeof options.yes === 'function') {
                options.yes.call(this);
            }
        } else {
            if (options.no && typeof options.no === 'function') {
                options.no.call(this);
            }
        }
    };

    this.start = function (options) {
        if (options.checkPreGuidedsetup) {
            this.isAllStepsCompleted({
                // TODO refactor this to implement promise pattern
                yes: function () {
                    // TODO refactor this to be DRY
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_IN_PROGRESS
                    });
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                    });
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT
                    });
                },
                no: function () {
                    this.startNormal(options);
                }
            });
        } else {
            this.startNormal(options);
        }
    };

    this.startNormal = function (options) {
        if (options.autoOpen) {
            setTimeout(function () {
                $('#cc-sa-item-guidedsetup').trigger('click');
            }, 500);
        }
        if (options.reminderCallout) {
            this.showCalloutReminder();
        }
        if (options.congratulationsCallout) {
            this.showCalloutCongratulations();
        }
        if (options.checkCongratulationsMsg) {
            setTimeout(function () {
                $('body').bind('bsa_event_called', function () {
                    me.checkCongratulationsMsg();
                    //api.destroyController('cc-sa-item-guidedsetup');
                    var
                        controller = siteadmin.getController('cc-sa-item-guidedsetup'),
                        isOpen = false;
                    if (controller !== null &&
                        typeof controller.isOpened === 'function' &&
                        controller.isOpened()
                    ) {
                        isOpen = true;
                    }
                    if (isOpen) {
                        api.disableCache();
                    } else {
                        api.destroyController('cc-sa-item-guidedsetup');
                    }
                });
                me.checkCongratulationsMsg();
            }, 700);
        }
    };

    this.show = function () {
        // on each show we should re-create share buttons
        // to prevent social sharing to use outdated cache
        // (url will have a timestamp in the query stirng)

        createFooterShareButtons();
        if (gsCompleted) {
            createStickyShareButtons();
        }
    };

    return this;

}.call(exports));



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/guidedSetup.js
 ** module id = 732
 ** module chunks = 0
 **/